import {
  Checkbox,
  Input,
  Modal,
  Spin,
  Form,
  Button,
  message,
  Tabs,
} from "antd";
import { ExclamationCircleFilled, UploadOutlined } from "@ant-design/icons";
import { useAudioRecorder } from "react-audio-voice-recorder";
import "./styles.scss";
import { useState, useEffect, Children, useRef } from "react";
import {
  putData,
  putFormData,
  fetchData,
  deleteData,
  putGetFormData,
} from "../../endpoints";
import { FileUploader } from "react-drag-drop-files";
import Cropper from "./CropVoice/src/index.tsx";
import { useReactToPrint } from "react-to-print";
import { PrintReport } from "./PrintReport.jsx";
import { async } from "q";
import { useLocation, useParams, useNavigate } from "react-router-dom";

const options = [
  {
    label: "Text",
    value: "Text",
  },
  {
    label: "Voice",
    value: "Voice",
  },
];

const ConfirmReport = ({
  template,
  setIsOpen,
  setIsEdit,
  setSelected,
  patient,
}) => {
  const componentRef = useRef();
  const path = useLocation().pathname;
  const { reportId, patientId } = useParams();
  const navigator = useNavigate();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const [questionnaire, setQuestionnaire] = useState(
    template
      ? template.sections
        ? template.sections.map((s) => {
            var q = s.questions.map((qu) => {
              return { ...qu, title: qu.question };
            });
            var sum = {
              voice: null,
              question: null,
            };
            s.results != undefined
              ? s.results.filter((sumary) => {
                  return sumary.inputType == "voice";
                })[0]
                ? (sum.voice = s.results.filter((sumary) => {
                    return sumary.inputType == "voice";
                  })[0].result)
                : (sum.voice = null)
              : (sum.voice = null);
            s.results != undefined
              ? s.results.filter((sumary) => {
                  return sumary.inputType == "question";
                })[0]
                ? (sum.question = s.results.filter((sumary) => {
                    return sumary.inputType == "question";
                  })[0].result)
                : (sum.question = null)
              : (sum.question = null);

            return {
              ...s,
              questions: q,
              audio: s.voices,
              summary: sum,
            };
          })
        : template
      : []
  );
  const [selectedType, setSelectedType] = useState("");
  const [fullscreen, setfullscrenn] = useState(true);
  const [summerytype, setsummerytype] = useState("Table");
  const [isEditCommand, setisEditCommand] = useState(-1);
  const [editassessment, seteditassessment] = useState(false);
  const [editdiagnose, seteditdiagnose] = useState(false);
  const [editRecommendation, seteditRecommendation] = useState(false);
  const [exportTamplate, setExportTemplate] = useState(null);
  const [uploadModal, setUploadmodal] = useState(false);
  const [final, setFinal] = useState({});
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalData, setModalData] = useState({});

  useEffect(() => {
    const savedState = sessionStorage.getItem("modalState");
    if (savedState) {
      setModalData(JSON.parse(savedState));
      setIsModalVisible(JSON.parse(savedState).showModal);
      sessionStorage.removeItem("modalState");
    }
  }, []);
  const uploadExport = async () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("file", exportTamplate.file);
    var input = summerytype == "Table" ? "question" : "voice";
    formData.append("inputType", input);

    var res = await putGetFormData(
      "admin/report/" + template.id + "/export",
      formData
    );
    if (res.status != 200) {
      Modal.error({ title: res });
    } else {
      const url = window.URL.createObjectURL(
        new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        })
      );
      const link = document.createElement("a");
      link.href = url;
      link.appendChild(
        document.createTextNode(`Download ${template.title}.docx`)
      );
      link.setAttribute("download", `${template.title}.docx`);
      if (document.getElementById("downloadButton").childNodes[0]) {
        document
          .getElementById("downloadButton")
          .replaceChild(
            link,
            document.getElementById("downloadButton").childNodes[0]
          );
      } else {
        document.getElementById("downloadButton").appendChild(link);
      }
    }

    setLoading(false);
  };
  const uploadFinal = async () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("file", final.file);

    var res = await putGetFormData(
      "admin/report/" + template.id + "/final-result",
      formData
    );
    if (res.status != 200) {
      Modal.error({ title: res });
    } else {
      setUploadmodal(false);
      Modal.success({ title: res.data.message });
    }
    setLoading(false);
  };
  var resOfQ = template.results.filter((r) => {
    return r.inputType == "question";
  });
  var resOfV = template.results.filter((r) => {
    return r.inputType == "voice";
  });
  const [otherReports, setOtherReports] = useState(
    template.results.length > 0
      ? {
          question: {
            assessment: resOfQ.filter((r) => {
              return r.type == "assessment";
            })[0]
              ? resOfQ.filter((r) => {
                  return r.type == "assessment";
                })[0].result
              : null,
            diagnose: resOfQ.filter((r) => {
              return r.type == "diagnose";
            })[0]
              ? resOfQ.filter((r) => {
                  return r.type == "diagnose";
                })[0].result
              : null,
            recommendation: resOfQ.filter((r) => {
              return r.type == "recommendation";
            })[0]
              ? resOfQ.filter((r) => {
                  return r.type == "recommendation";
                })[0].result
              : null,
          },
          voice: {
            assessment: resOfV.filter((r) => {
              return r.type == "assessment";
            })[0]
              ? resOfV.filter((r) => {
                  return r.type == "assessment";
                })[0].result
              : null,
            diagnose: resOfV.filter((r) => {
              return r.type == "diagnose";
            })[0]
              ? resOfV.filter((r) => {
                  return r.type == "diagnose";
                })[0].result
              : null,
            recommendation: resOfV.filter((r) => {
              return r.type == "recommendation";
            })[0]
              ? resOfV.filter((r) => {
                  return r.type == "recommendation";
                })[0].result
              : null,
          },
        }
      : null
  );
  const [loading, setLoading] = useState(false);
  const [printmodal, setprintmodal] = useState(false);

  useEffect(() => {
    setQuestionnaire(questionnaire);
  }, [loading]);

  const onChange = (checkedValues) => {
    setSelectedType(checkedValues);
  };
  const handleOk = async (results, type) => {
    setLoading(true);

    for (var i in results) {
      if (
        (i == "question" &&
          selectedType.indexOf("Text") > -1 &&
          results.question != null) ||
        (i == "voice" &&
          selectedType.indexOf("Voice") > -1 &&
          results.voice != null)
      ) {
        var res = await putData(`admin/report/${template.id}/result`, {
          reportId: template.id,
          inputType: i,
          type: type,
          result: i == "question" ? results.question : results.voice,
        });
        if (res.status !== 200) {
          Modal.error({ title: res });
        } else {
          switch (type) {
            case "assessment":
              await setOtherReports({
                question: {
                  ...otherReports.question,
                  assessment: results.question,
                },
                voice: { ...otherReports.voice, assessment: results.voice },
              });
              break;
            case "diagnose":
              await setOtherReports({
                question: {
                  ...otherReports.question,
                  diagnose: results.question,
                },
                voice: { ...otherReports.voice, diagnose: results.voice },
              });
              break;
            case "recommendation":
              setOtherReports({
                question: {
                  ...otherReports.question,
                  recommendation: results.question,
                },
                voice: { ...otherReports.voice, recommendation: results.voice },
              });
              break;
          }
        }
      }
    }
    setLoading(false);
  };
  const runReport = async (type) => {
    setLoading(true);
    Modal.info({
      title: "It may take a few minutes to generate the report. Please wait.",
    });
    var res = await putData(`admin/report/${template.id}/run`, { type: type });

    if (res.status == 200) {
      Modal.confirm({
        width: "80%",
        height: "80%",
        title:
          "Do you want to keep the previous answer of this command or replace the new answer? ",
        onOk() {
          handleOk(res.data.data, type);
        },
        content: (
          <div className="d-flex flex-row gap-4 col-12">
            <Tabs
              size={"middle"}
              tabBarGutter={18}
              style={{ color: "black", fontWeight: "600", width: "97%" }}
              className="col-12 h-100"
              defaultActiveKey={1}
              type="card"
              items={[
                {
                  key: "1",
                  label: "New Answer",
                  children: (
                    <div className="d-flex flex-row col-12 gap-2">
                      <div
                        style={{
                          border: "2px solid rgba(217, 217, 217, 1)",
                          borderRadius: "10px",
                        }}
                        className="d-flex flex-column col-6"
                      >
                        <div
                          className="col-12 py-3"
                          style={{
                            fontSize: "16px",
                            fontWeight: "500",
                            textAlign: "center",
                            borderBottom: " 2px solid rgba(217, 217, 217, 1)",
                          }}
                        >
                          Answer by voice
                        </div>

                        <div style={{ maxHeight: "40vh", overflowY: "scroll" }}>
                          {" "}
                          <div
                            className="px-3 py-3 col-12"
                            style={{ textAlign: "center" }}
                          >
                            <h3
                              style={{
                                fontSize: "14px",
                                fontWeight: "500 ",
                              }}
                            >
                              {type}
                            </h3>
                            <p
                              style={{
                                fontSize: "13px",
                                fontWeight: "400 ",
                              }}
                            >
                              {res.data.data.voice}
                            </p>
                          </div>
                          {/* <div
                            className="px-3 py-3 col-12"
                            style={{ textAlign: "center" }}
                          >
                            <h3
                              style={{
                                fontSize: "14px",
                                fontWeight: "500 ",
                              }}
                            >
                              Diagnosis
                            </h3>
                            <p
                              style={{
                                fontSize: "13px",
                                fontWeight: "400 ",
                              }}
                            >
                              {res.data.data.voice.recommendation}
                            </p>
                          </div>
                          <div
                            className="px-3 py-3 col-12"
                            style={{ textAlign: "center" }}
                          >
                            <h3
                              style={{
                                fontSize: "14px",
                                fontWeight: "500 ",
                              }}
                            >
                              Recommendations
                            </h3>
                            <p
                              style={{
                                fontSize: "13px",
                                fontWeight: "400 ",
                              }}
                            >
                              {res.data.data.voice.recommendation}
                            </p>
                          </div> */}
                        </div>
                      </div>
                      <div
                        style={{
                          border: "2px solid rgba(217, 217, 217, 1)",
                          borderRadius: "10px",
                        }}
                        className="d-flex flex-column col-6"
                      >
                        <div
                          className="col-12 py-3"
                          style={{
                            fontSize: "16px",
                            fontWeight: "500",
                            textAlign: "center",
                            borderBottom: " 2px solid rgba(217, 217, 217, 1)",
                          }}
                        >
                          Answer by Table
                        </div>
                        <div
                          style={{
                            maxHeight: "40vh",
                            overflowY: "scroll",
                          }}
                        >
                          <div
                            className="px-3 py-3 col-12"
                            style={{ textAlign: "center" }}
                          >
                            <h3
                              style={{
                                fontSize: "14px",
                                fontWeight: "500 ",
                              }}
                            >
                              {type}
                            </h3>
                            <p
                              style={{
                                fontSize: "13px",
                                fontWeight: "400 ",
                              }}
                            >
                              {res.data.data.question}
                            </p>
                          </div>

                          {/* <div
                            className="px-3 py-3 col-12"
                            style={{ textAlign: "center" }}
                          >
                            <h3
                              style={{
                                fontSize: "14px",
                                fontWeight: "500 ",
                              }}
                            >
                              Diagnosis
                            </h3>
                            <p
                              style={{
                                fontSize: "13px",
                                fontWeight: "400 ",
                              }}
                            >
                              {res.data.data.question.recommendation}
                            </p>
                          </div>
                          <div
                            className="px-3 py-3 col-12"
                            style={{ textAlign: "center" }}
                          >
                            <h3
                              style={{
                                fontSize: "14px",
                                fontWeight: "500 ",
                              }}
                            >
                              Recommendations
                            </h3>
                            <p
                              style={{
                                fontSize: "13px",
                                fontWeight: "400 ",
                              }}
                            >
                              {res.data.data.question.recommendation}
                            </p>
                          </div> */}
                        </div>
                      </div>
                    </div>
                  ),
                },
                {
                  key: "2",
                  label: "Previous Answer",
                  children: (
                    <div className="d-flex flex-row col-12 gap-2">
                      <div
                        style={{
                          border: "2px solid rgba(217, 217, 217, 1)",
                          borderRadius: "10px",
                        }}
                        className="d-flex flex-column col-6"
                      >
                        <div
                          className="col-12 py-3"
                          style={{
                            fontSize: "16px",
                            fontWeight: "500",
                            textAlign: "center",
                            borderBottom: " 2px solid rgba(217, 217, 217, 1)",
                          }}
                        >
                          Answer by voice
                        </div>
                        {otherReports && (
                          <div
                            style={{ maxHeight: "40vh", overflowY: "scroll" }}
                          >
                            {" "}
                            <div
                              className="px-3 py-3 col-12"
                              style={{ textAlign: "center" }}
                            >
                              <h3
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "500 ",
                                }}
                              >
                                {type}
                              </h3>
                              <p
                                style={{
                                  fontSize: "13px",
                                  fontWeight: "400 ",
                                }}
                              >
                                {type == "assessment"
                                  ? otherReports.voice.assessment
                                  : type == "diagnose"
                                  ? otherReports.voice.diagnose
                                  : otherReports.voice.recommendation}
                              </p>
                            </div>
                            {/* <div
                              className="px-3 py-3 col-12"
                              style={{ textAlign: "center" }}
                            >
                              <h3
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "500 ",
                                }}
                              >
                                Diagnosis
                              </h3>
                              <p
                                style={{
                                  fontSize: "13px",
                                  fontWeight: "400 ",
                                }}
                              >
                                {otherReports.voice.recommendation}
                              </p>
                            </div>
                            <div
                              className="px-3 py-3 col-12"
                              style={{ textAlign: "center" }}
                            >
                              <h3
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "500 ",
                                }}
                              >
                                Recommendations
                              </h3>
                              <p
                                style={{
                                  fontSize: "13px",
                                  fontWeight: "400 ",
                                }}
                              >
                                {otherReports.voice.recommendation}
                              </p>
                            </div> */}
                          </div>
                        )}
                      </div>
                      <div
                        style={{
                          border: "2px solid rgba(217, 217, 217, 1)",
                          borderRadius: "10px",
                        }}
                        className="d-flex flex-column col-6"
                      >
                        <div
                          className="col-12 py-3"
                          style={{
                            fontSize: "16px",
                            fontWeight: "500",
                            textAlign: "center",
                            borderBottom: " 2px solid rgba(217, 217, 217, 1)",
                          }}
                        >
                          Answer by Table
                        </div>
                        {otherReports && (
                          <div
                            style={{ maxHeight: "50vh", overflowY: "scroll" }}
                          >
                            {" "}
                            <div
                              className="px-3 py-3 col-12"
                              style={{ textAlign: "center" }}
                            >
                              <h3
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "500 ",
                                }}
                              >
                                {type}
                              </h3>
                              <p
                                style={{
                                  fontSize: "13px",
                                  fontWeight: "400 ",
                                }}
                              >
                                {type == "assessment"
                                  ? otherReports.question.assessment
                                  : type == "diagnose"
                                  ? otherReports.question.diagnose
                                  : otherReports.question.recommendation}
                              </p>
                            </div>
                            {/* <div
                              className="px-3 py-3 col-12"
                              style={{ textAlign: "center" }}
                            >
                              <h3
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "500 ",
                                }}
                              >
                                Diagnosis
                              </h3>
                              <p
                                style={{
                                  fontSize: "13px",
                                  fontWeight: "400 ",
                                }}
                              >
                                {otherReports.question.recommendation}
                              </p>
                            </div>
                            <div
                              className="px-3 py-3 col-12"
                              style={{ textAlign: "center" }}
                            >
                              <h3
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "500 ",
                                }}
                              >
                                Recommendations
                              </h3>
                              <p
                                style={{
                                  fontSize: "13px",
                                  fontWeight: "400 ",
                                  maxHeight: "40vh",
                                }}
                              >
                                {otherReports.question.recommendation}
                              </p>
                            </div> */}
                          </div>
                        )}
                      </div>
                    </div>
                  ),
                },
              ]}
            />
          </div>
        ),
        icon: <ExclamationCircleFilled />,
        okText: "Replace new answer",
        okType: "danger",
        cancelText: "Keep the previous",
        onCancel() {},
      });
      setLoading(false);
    }
    setLoading(false);
  };
  const editCommand = async (command) => {
    var res = await putData("admin/report-command/" + command.id, {
      ...command,
      answerByQuestion: command.answerByQuestion,
      answerByVoice: command.answerByVoice,
    });
    if (res.status != 200) {
      Modal.error({ title: res });
    }
  };
  const editResult = async (result) => {
    var res = await putData(`admin/report/${template.id}/result`, {
      type: result.type,
      reportId: template.id,
      inputType: result.inputType,
      result: result.result,
    });
    if (res.status !== 200) {
      Modal.error({ title: "Warning", content: res });
    }
  };

  return (
    <div>
      <div className={!fullscreen ? "hidden" : "show"}>
        <svg
          style={{ marginBottom: "20px" }}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          onClick={() => {
            setSelected({
              title: template.title,
              id: template.id,
              sections: questionnaire,
              results: template.results,
            });
            setIsEdit(true);
            setIsOpen(false);
            // console.log(reportId);
            navigator(`/patients/${patientId}/reports/${reportId}`);
          }}
        >
          <path
            d="M22.7996 11.3956H2.65334L10.0208 4.01421C10.2528 3.78219 10.2528 3.40603 10.0208 3.17401C9.7889 2.942 9.41285 2.942 9.18091 3.17401L0.781469 11.576C0.665495 11.6847 0.599609 11.8369 0.599609 11.996C0.599609 12.1552 0.665498 12.3074 0.781469 12.4161L9.18091 20.8181C9.28965 20.9341 9.44178 21 9.60088 21C9.75997 21 9.91211 20.9341 10.0208 20.8181C10.1368 20.7093 10.2027 20.5571 10.2027 20.398C10.2027 20.2388 10.1368 20.0867 10.0208 19.9779L2.65334 12.5965H22.7996C23.131 12.5965 23.3996 12.3278 23.3996 11.9964C23.3996 11.665 23.131 11.3963 22.7996 11.3963V11.3956Z"
            fill="#18324E"
          />
        </svg>
        <div
          className="report"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <h1>Questionnaire</h1>
          <div style={{ border: "black 2px solid", padding: "10px 20px" }}>
            <h1
              style={{
                background: "white",
                marginTop: "-20px",
                textAlign: "center",
              }}
            >
              input Type
            </h1>
            <Checkbox.Group options={options} onChange={onChange} />
          </div>
        </div>
        <div className="d-flex flex-column clo-12 my-4">
          <div className="body-part">
            {questionnaire && questionnaire.length == 0
              ? " Here, First add questions, or import an assessment."
              : questionnaire.map((section, i) => {
                  return (
                    <Section
                      section={questionnaire[i]}
                      questionnaire={questionnaire}
                      setQuestionnaire={setQuestionnaire}
                      index={i}
                      selectedType={selectedType}
                      template={template}
                      setReportLoading={setLoading}
                    />
                  );
                })}
          </div>
        </div>
      </div>
      {fullscreen ? (
        <></>
      ) : (
        <div className="d-flex flex-row gap-2 my-2 mx-3">
          <Button
            onClick={async () => {
              await runReport("assessment");
            }}
            size="middle"
            loading={loading}
            style={{ backgroundColor: "rgba(76, 76, 76, 1)", color: "white" }}
          >
            Assessment
          </Button>
          <Button
            onClick={async () => {
              await runReport("diagnose");
            }}
            size="middle"
            loading={loading}
            disabled={
              !otherReports ||
              (!otherReports.question.assessment == "" &&
                !otherReports.voice.assessment == "")
            }
            style={{ backgroundColor: "rgba(76, 76, 76, 1)", color: "white" }}
          >
            Diagnosis
          </Button>
          <Button
            onClick={async () => {
              await runReport("recommendation");
            }}
            disabled={
              !otherReports ||
              (!otherReports.question.diagnose == "" &&
                !otherReports.voice.diagnose == "")
            }
            size="middle"
            loading={loading}
            style={{ backgroundColor: "rgba(76, 76, 76, 1)", color: "white" }}
          >
            Recommendation
          </Button>
        </div>
      )}
      <div
        className="my-5"
        style={{ display: "flex", justifyContent: "space-around" }}
      >
        <div className="col-10 align-items-center d-flex flex-column">
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              width: "98%",
              zIndex: "2",
            }}
          >
            <div
              onClick={() => {
                setsummerytype("Table");
                seteditRecommendation(false);
                seteditassessment(false);
                seteditdiagnose(false);
              }}
              className={summerytype == "Table" ? "summeryselected" : "summery"}
            >
              {summerytype == "Table" ? (
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ marginRight: "5px" }}
                >
                  <rect width="15" height="15" fill="#1E1E1E" />
                  <rect
                    width="1440"
                    height="1644"
                    transform="translate(-481 -973)"
                    fill="white"
                  />
                  <rect
                    x="0.5"
                    y="0.5"
                    width="14"
                    height="14"
                    rx="1.5"
                    stroke="#868686"
                  />
                  <rect
                    x="2"
                    y="2"
                    width="11"
                    height="11"
                    rx="1"
                    fill="#868686"
                  />
                </svg>
              ) : (
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ marginRight: "5px" }}
                >
                  <rect
                    x="0.5"
                    y="0.5"
                    width="14"
                    height="14"
                    rx="1.5"
                    stroke="#868686"
                  />
                </svg>
              )}
              Table
            </div>
            <div
              onClick={() => {
                setsummerytype("Voice");
                seteditRecommendation(false);
                seteditassessment(false);
                seteditdiagnose(false);
              }}
              className={
                summerytype == "Voice" ? "summeryselectedvois" : "summery"
              }
            >
              {summerytype == "Voice" ? (
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ marginRight: "5px" }}
                >
                  <rect width="15" height="15" fill="#1E1E1E" />
                  <rect
                    width="1440"
                    height="1644"
                    transform="translate(-481 -973)"
                    fill="white"
                  />
                  <rect
                    x="0.5"
                    y="0.5"
                    width="14"
                    height="14"
                    rx="1.5"
                    stroke="#868686"
                  />
                  <rect
                    x="2"
                    y="2"
                    width="11"
                    height="11"
                    rx="1"
                    fill="#868686"
                  />
                </svg>
              ) : (
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ marginRight: "5px" }}
                >
                  <rect
                    x="0.5"
                    y="0.5"
                    width="14"
                    height="14"
                    rx="1.5"
                    stroke="#868686"
                  />
                </svg>
              )}
              Voice
            </div>
          </div>
          <div
            className="w-100"
            style={
              fullscreen
                ? {
                    border: "3px #d9d9d9 solid",
                    borderRadius: "7px",
                    height: "60vh",
                    overflowY: "scroll",
                    padding: "10px 15px",
                    marginTop: "-1px",
                  }
                : {
                    border: "3px #d9d9d9 solid",
                    borderRadius: "7px",
                    height: "100vh",
                    padding: "10px 15px",
                    marginTop: "-1px",
                    overflow: "scroll",
                  }
            }
          >
            <Spin spinning={loading} tip="Loading" size="large">
              {summerytype == "Table" ? (
                <>
                  {questionnaire.map((section, index) => {
                    return (
                      <>
                        {questionnaire[index].commands.map((c, i) => {
                          if (questionnaire[index].commands[i].answerByQuestion)
                            return (
                              <div style={{ color: "black" }}>
                                <div
                                  style={{
                                    width: "100%",
                                    marginBottom: "-25px",
                                    marginRight: "10px",
                                    direction: "rtl",
                                    zIndex: 3,
                                    position: "relative",
                                  }}
                                >
                                  <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 35 35"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginRight: "5px" }}
                                    onClick={() => {
                                      if (isEditCommand == c.id) {
                                        editCommand(
                                          questionnaire[index].commands[i]
                                        );
                                        setisEditCommand(-1);
                                      } else setisEditCommand(c.id);
                                    }}
                                  >
                                    <rect
                                      width="35"
                                      height="35"
                                      rx="5"
                                      fill="#4C4C4C"
                                    />
                                    <path
                                      d="M23.7754 8.75C23.1421 8.75 22.5088 8.99117 22.0254 9.47461L21 10.5L24.5 14L25.5254 12.9746C26.4914 12.0086 26.4914 10.4415 25.5254 9.47461C25.042 8.99117 24.4087 8.75 23.7754 8.75ZM19.6875 11.8125L9.625 21.875V25.375H13.125L23.1875 15.3125L19.6875 11.8125Z"
                                      fill="white"
                                    />
                                  </svg>
                                </div>
                                <h3
                                  style={{
                                    fontWeight: "600",
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                  className="px-3"
                                >
                                  {questionnaire[index].commands[i].title}
                                </h3>

                                {isEditCommand == c.id ? (
                                  <Input.TextArea
                                    style={{
                                      minHeight: "100px",
                                      marginTop: "30px",
                                    }}
                                    onChange={(e) => {
                                      var temp = questionnaire;
                                      temp[index].commands[i] = {
                                        ...temp[index].commands[i],
                                        answerByQuestion: e.target.value,
                                      };
                                      setQuestionnaire(temp);
                                    }}
                                    defaultValue={
                                      questionnaire[index].commands[i]
                                        .answerByQuestion
                                    }
                                  />
                                ) : (
                                  <p
                                    style={{ overflowWrap: "normal" }}
                                    className="px-4 py-2"
                                  >
                                    {
                                      questionnaire[index].commands[i]
                                        .answerByQuestion
                                    }
                                  </p>
                                )}
                                <hr></hr>
                              </div>
                            );
                        })}
                        {questionnaire[index].summary && (
                          <div
                            style={{
                              width: "100%",
                              direction: "rtl",
                              position: "relative",
                              zIndex: 3,
                              marginRight: "10px",
                              textAlign: "left",
                            }}
                          >
                            <h3
                              style={{
                                fontWeight: "600",
                                color: "rgba(20, 95, 172, 1)",
                              }}
                              className="px-3"
                            >
                              Summary of {questionnaire[index].title}
                            </h3>
                            <p
                              style={{
                                overflowWrap: "normal",
                                color: "rgba(20, 95, 172, 1)",
                              }}
                              className="px-4"
                            >
                              {questionnaire[index].summary.question}
                            </p>
                            <hr></hr>
                          </div>
                        )}
                      </>
                    );
                  })}
                  {otherReports && (
                    <>
                      <div
                        style={{
                          width: "100%",
                          direction: "rtl",
                          position: "relative",
                          zIndex: 3,
                          marginRight: "10px",
                          textAlign: "left",
                        }}
                      >
                        <h3
                          style={{
                            fontWeight: "600",
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                          className="px-3"
                        >
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 35 35"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{ marginRight: "5px" }}
                            onClick={() => {
                              seteditassessment((prev) => !prev);
                              if (editassessment) {
                                editResult({
                                  result: otherReports.question.assessment,
                                  type: "assessment",
                                  inputType: "question",
                                });
                              }
                            }}
                          >
                            <rect
                              width="35"
                              height="35"
                              rx="5"
                              fill="#4C4C4C"
                            />
                            <path
                              d="M23.7754 8.75C23.1421 8.75 22.5088 8.99117 22.0254 9.47461L21 10.5L24.5 14L25.5254 12.9746C26.4914 12.0086 26.4914 10.4415 25.5254 9.47461C25.042 8.99117 24.4087 8.75 23.7754 8.75ZM19.6875 11.8125L9.625 21.875V25.375H13.125L23.1875 15.3125L19.6875 11.8125Z"
                              fill="white"
                            />
                          </svg>
                          Assessment
                        </h3>

                        {editassessment ? (
                          <Input.TextArea
                            style={{
                              minHeight: "100px",
                              marginTop: "30px",
                            }}
                            dir="ltr"
                            onChange={(e) => {
                              otherReports.question.assessment = e.target.value;
                            }}
                            defaultValue={otherReports.question.assessment}
                          />
                        ) : (
                          <p
                            style={{
                              overflowWrap: "normal",
                            }}
                            className="px-4"
                          >
                            {otherReports.question.assessment}
                          </p>
                        )}

                        <hr></hr>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          direction: "rtl",
                          position: "relative",
                          zIndex: 3,
                          marginRight: "10px",
                          textAlign: "left",
                        }}
                      >
                        <h3
                          style={{
                            fontWeight: "600",
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                          className="px-3"
                        >
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 35 35"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{ marginRight: "5px" }}
                            onClick={() => {
                              seteditdiagnose((prev) => !prev);
                              if (editdiagnose) {
                                editResult({
                                  result: otherReports.question.diagnose,
                                  type: "diagnose",
                                  inputType: "question",
                                });
                              }
                            }}
                          >
                            <rect
                              width="35"
                              height="35"
                              rx="5"
                              fill="#4C4C4C"
                            />
                            <path
                              d="M23.7754 8.75C23.1421 8.75 22.5088 8.99117 22.0254 9.47461L21 10.5L24.5 14L25.5254 12.9746C26.4914 12.0086 26.4914 10.4415 25.5254 9.47461C25.042 8.99117 24.4087 8.75 23.7754 8.75ZM19.6875 11.8125L9.625 21.875V25.375H13.125L23.1875 15.3125L19.6875 11.8125Z"
                              fill="white"
                            />
                          </svg>
                          Diagnose
                        </h3>
                        {editdiagnose ? (
                          <Input.TextArea
                            style={{
                              minHeight: "100px",
                              marginTop: "30px",
                            }}
                            dir="ltr"
                            onChange={(e) => {
                              otherReports.question.diagnose = e.target.value;
                            }}
                            defaultValue={otherReports.question.diagnose}
                          />
                        ) : (
                          <p
                            style={{
                              overflowWrap: "normal",
                            }}
                            className="px-4"
                          >
                            {otherReports.question.diagnose}
                          </p>
                        )}

                        <hr></hr>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          direction: "rtl",
                          position: "relative",
                          zIndex: 3,
                          marginRight: "10px",
                          textAlign: "left",
                        }}
                      >
                        <h3
                          style={{
                            fontWeight: "600",
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                          className="px-3"
                        >
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 35 35"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{ marginRight: "5px" }}
                            onClick={() => {
                              seteditRecommendation((prev) => !prev);
                              if (editRecommendation) {
                                editResult({
                                  result: otherReports.question.recommendation,
                                  type: "recommendation",
                                  inputType: "question",
                                });
                              }
                            }}
                          >
                            <rect
                              width="35"
                              height="35"
                              rx="5"
                              fill="#4C4C4C"
                            />
                            <path
                              d="M23.7754 8.75C23.1421 8.75 22.5088 8.99117 22.0254 9.47461L21 10.5L24.5 14L25.5254 12.9746C26.4914 12.0086 26.4914 10.4415 25.5254 9.47461C25.042 8.99117 24.4087 8.75 23.7754 8.75ZM19.6875 11.8125L9.625 21.875V25.375H13.125L23.1875 15.3125L19.6875 11.8125Z"
                              fill="white"
                            />
                          </svg>
                          Recommendation
                        </h3>
                        {editRecommendation ? (
                          <Input.TextArea
                            style={{
                              minHeight: "100px",
                              marginTop: "30px",
                            }}
                            dir="ltr"
                            onChange={(e) => {
                              otherReports.question.recommendation =
                                e.target.value;
                            }}
                            defaultValue={otherReports.question.recommendation}
                          />
                        ) : (
                          <p
                            style={{
                              overflowWrap: "normal",
                            }}
                            className="px-4"
                          >
                            {otherReports.question.recommendation}
                          </p>
                        )}
                        <hr></hr>
                      </div>
                    </>
                  )}
                </>
              ) : (
                <>
                  {questionnaire.map((section, index) => {
                    return (
                      <>
                        {questionnaire[index].commands.map((c, i) => {
                          if (questionnaire[index].commands[i].answerByVoice)
                            return (
                              <div style={{ color: "black" }}>
                                <div
                                  style={{
                                    width: "100%",
                                    marginBottom: "-25px",
                                    direction: "rtl",
                                    position: "relative",
                                    zIndex: 3,
                                    marginRight: "10px",
                                  }}
                                >
                                  <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 35 35"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginRight: "5px" }}
                                    onClick={() => {
                                      if (isEditCommand == c.id) {
                                        editCommand(
                                          questionnaire[index].commands[i]
                                        );
                                        setisEditCommand(-1);
                                      } else setisEditCommand(c.id);
                                    }}
                                  >
                                    <rect
                                      width="35"
                                      height="35"
                                      rx="5"
                                      fill="#4C4C4C"
                                    />
                                    <path
                                      d="M23.7754 8.75C23.1421 8.75 22.5088 8.99117 22.0254 9.47461L21 10.5L24.5 14L25.5254 12.9746C26.4914 12.0086 26.4914 10.4415 25.5254 9.47461C25.042 8.99117 24.4087 8.75 23.7754 8.75ZM19.6875 11.8125L9.625 21.875V25.375H13.125L23.1875 15.3125L19.6875 11.8125Z"
                                      fill="white"
                                    />
                                  </svg>
                                </div>
                                <h3
                                  style={{
                                    fontWeight: "600",
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                  className="px-3"
                                >
                                  {questionnaire[index].commands[i].title}
                                </h3>
                                {isEditCommand == c.id ? (
                                  <Input.TextArea
                                    style={{
                                      minHeight: "100px",
                                      marginTop: "30px",
                                    }}
                                    onChange={(e) => {
                                      var temp = questionnaire;
                                      temp[index].commands[i] = {
                                        ...temp[index].commands[i],
                                        answerByVoice: e.target.value,
                                      };
                                      setQuestionnaire(temp);
                                    }}
                                    defaultValue={
                                      questionnaire[index].commands[i]
                                        .answerByVoice
                                    }
                                  />
                                ) : (
                                  <p
                                    style={{ overflowWrap: "normal" }}
                                    className="px-4 py-2"
                                  >
                                    {
                                      questionnaire[index].commands[i]
                                        .answerByVoice
                                    }
                                  </p>
                                )}

                                <hr></hr>
                              </div>
                            );
                        })}
                        {questionnaire[index].summary && (
                          <div
                            style={{
                              width: "100%",
                              direction: "rtl",
                              position: "relative",
                              zIndex: 3,
                              marginRight: "10px",
                              textAlign: "left",
                            }}
                            dir="ltr"
                          >
                            <h3
                              style={{
                                fontWeight: "600",
                                color: "rgba(20, 95, 172, 1)",
                              }}
                              className="px-3"
                            >
                              Summary of {questionnaire[index].title}
                            </h3>
                            <p
                              style={{
                                overflowWrap: "normal",
                                color: "rgba(20, 95, 172, 1)",
                              }}
                              className="px-4"
                            >
                              {questionnaire[index].summary.voice}
                            </p>
                            <hr />
                          </div>
                        )}
                      </>
                    );
                  })}
                  {otherReports && (
                    <>
                      <div
                        style={{
                          width: "100%",
                          direction: "rtl",
                          position: "relative",
                          zIndex: 3,
                          marginRight: "10px",
                          textAlign: "left",
                        }}
                      >
                        <h3
                          style={{
                            fontWeight: "600",
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                          className="px-3"
                        >
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 35 35"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{ marginRight: "5px" }}
                            onClick={() => {
                              seteditassessment((prev) => !prev);
                              if (editassessment) {
                                editResult({
                                  result: otherReports.voice.assessment,
                                  type: "assessment",
                                  inputType: "voice",
                                });
                              }
                            }}
                          >
                            <rect
                              width="35"
                              height="35"
                              rx="5"
                              fill="#4C4C4C"
                            />
                            <path
                              d="M23.7754 8.75C23.1421 8.75 22.5088 8.99117 22.0254 9.47461L21 10.5L24.5 14L25.5254 12.9746C26.4914 12.0086 26.4914 10.4415 25.5254 9.47461C25.042 8.99117 24.4087 8.75 23.7754 8.75ZM19.6875 11.8125L9.625 21.875V25.375H13.125L23.1875 15.3125L19.6875 11.8125Z"
                              fill="white"
                            />
                          </svg>
                          Assessment
                        </h3>

                        {editassessment ? (
                          <Input.TextArea
                            style={{
                              minHeight: "100px",
                              marginTop: "30px",
                            }}
                            dir="ltr"
                            onChange={(e) => {
                              otherReports.voice.assessment = e.target.value;
                            }}
                            defaultValue={otherReports.voice.assessment}
                          />
                        ) : (
                          <p
                            style={{
                              overflowWrap: "normal",
                            }}
                            className="px-4"
                          >
                            {otherReports.voice.assessment}
                          </p>
                        )}

                        <hr />
                      </div>
                      <div
                        style={{
                          width: "100%",
                          direction: "rtl",
                          position: "relative",
                          zIndex: 3,
                          marginRight: "10px",
                          textAlign: "left",
                        }}
                      >
                        <h3
                          style={{
                            fontWeight: "600",
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                          className="px-3"
                        >
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 35 35"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{ marginRight: "5px" }}
                            onClick={() => {
                              seteditdiagnose((prev) => !prev);
                              if (editdiagnose) {
                                editResult({
                                  result: otherReports.voice.diagnose,
                                  type: "diagnose",
                                  inputType: "voice",
                                });
                              }
                            }}
                          >
                            <rect
                              width="35"
                              height="35"
                              rx="5"
                              fill="#4C4C4C"
                            />
                            <path
                              d="M23.7754 8.75C23.1421 8.75 22.5088 8.99117 22.0254 9.47461L21 10.5L24.5 14L25.5254 12.9746C26.4914 12.0086 26.4914 10.4415 25.5254 9.47461C25.042 8.99117 24.4087 8.75 23.7754 8.75ZM19.6875 11.8125L9.625 21.875V25.375H13.125L23.1875 15.3125L19.6875 11.8125Z"
                              fill="white"
                            />
                          </svg>
                          Diagnose
                        </h3>
                        {editdiagnose ? (
                          <Input.TextArea
                            style={{
                              minHeight: "100px",
                              marginTop: "30px",
                            }}
                            dir="ltr"
                            onChange={(e) => {
                              otherReports.voice.diagnose = e.target.value;
                            }}
                            defaultValue={otherReports.voice.diagnose}
                          />
                        ) : (
                          <p
                            style={{
                              overflowWrap: "normal",
                            }}
                            className="px-4"
                          >
                            {otherReports.voice.diagnose}
                          </p>
                        )}

                        <hr></hr>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          direction: "rtl",
                          position: "relative",
                          zIndex: 3,
                          marginRight: "10px",
                          textAlign: "left",
                        }}
                      >
                        <h3
                          style={{
                            fontWeight: "600",
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                          className="px-3"
                        >
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 35 35"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{ marginRight: "5px" }}
                            onClick={() => {
                              seteditRecommendation((prev) => !prev);
                              if (editRecommendation) {
                                editResult({
                                  result: otherReports.voice.recommendation,
                                  type: "recommendation",
                                  inputType: "voice",
                                });
                              }
                            }}
                          >
                            <rect
                              width="35"
                              height="35"
                              rx="5"
                              fill="#4C4C4C"
                            />
                            <path
                              d="M23.7754 8.75C23.1421 8.75 22.5088 8.99117 22.0254 9.47461L21 10.5L24.5 14L25.5254 12.9746C26.4914 12.0086 26.4914 10.4415 25.5254 9.47461C25.042 8.99117 24.4087 8.75 23.7754 8.75ZM19.6875 11.8125L9.625 21.875V25.375H13.125L23.1875 15.3125L19.6875 11.8125Z"
                              fill="white"
                            />
                          </svg>
                          Recommendation
                        </h3>
                        {editRecommendation ? (
                          <Input.TextArea
                            style={{
                              minHeight: "100px",
                              marginTop: "30px",
                            }}
                            dir="ltr"
                            onChange={(e) => {
                              otherReports.voice.recommendation =
                                e.target.value;
                            }}
                            defaultValue={otherReports.voice.recommendation}
                          />
                        ) : (
                          <p
                            style={{
                              overflowWrap: "normal",
                            }}
                            className="px-4"
                          >
                            {otherReports.voice.recommendation}
                          </p>
                        )}
                        <hr></hr>
                      </div>
                    </>
                  )}
                </>
              )}
            </Spin>
          </div>
        </div>
        <div className={fullscreen ? "col-2" : "col-0.5"}>
          <div
            style={
              fullscreen
                ? { display: "flex", justifyContent: "center" }
                : { display: "block" }
            }
          >
            <div
              onClick={() => {
                setfullscrenn((prev) => !prev);
              }}
            >
              {fullscreen ? (
                <svg
                  width="35"
                  height="35"
                  viewBox="0 0 35 35"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{
                    marginBottom: "5px",
                    display: "block",
                    marginRight: "5px",
                  }}
                >
                  <rect width="35" height="35" rx="5" fill="#4C4C4C" />
                  <path
                    d="M8.75361 7.87536C8.62847 7.87539 8.50478 7.90226 8.39091 7.95416C8.27703 8.00606 8.17561 8.08178 8.09348 8.17621C8.01136 8.27064 7.95045 8.38159 7.91486 8.50157C7.87926 8.62155 7.86982 8.74776 7.88716 8.8717V14.0089C7.88552 14.1249 7.90694 14.24 7.95018 14.3476C7.99341 14.4552 8.05761 14.5531 8.13902 14.6357C8.22043 14.7182 8.31745 14.7838 8.42442 14.8286C8.5314 14.8733 8.6462 14.8964 8.76216 14.8964C8.87812 14.8964 8.99292 14.8733 9.0999 14.8286C9.20687 14.7838 9.30389 14.7182 9.3853 14.6357C9.46671 14.5531 9.5309 14.4552 9.57414 14.3476C9.61738 14.24 9.6388 14.1249 9.63716 14.0089V10.8712L13.831 15.0651C13.9116 15.149 14.0082 15.2161 14.1151 15.2623C14.2219 15.3085 14.3369 15.3329 14.4533 15.334C14.5698 15.3352 14.6852 15.3132 14.793 15.2692C14.9008 15.2252 14.9987 15.1601 15.081 15.0778C15.1634 14.9955 15.2284 14.8975 15.2724 14.7898C15.3164 14.682 15.3385 14.5665 15.3373 14.4501C15.3361 14.3337 15.3117 14.2187 15.2655 14.1118C15.2193 14.005 15.1523 13.9084 15.0683 13.8278L10.8745 9.63391H14.0122C14.1281 9.63555 14.2432 9.61413 14.3508 9.57089C14.4584 9.52765 14.5563 9.46346 14.6389 9.38205C14.7215 9.30064 14.7871 9.20362 14.8318 9.09665C14.8766 8.98967 14.8996 8.87487 14.8996 8.75891C14.8996 8.64295 14.8766 8.52815 14.8318 8.42117C14.7871 8.3142 14.7215 8.21718 14.6389 8.13577C14.5563 8.05436 14.4584 7.99016 14.3508 7.94693C14.2432 7.90369 14.1281 7.88227 14.0122 7.88391H8.8647C8.82789 7.8787 8.79079 7.87585 8.75361 7.87536ZM26.2451 7.87536C26.2125 7.8764 26.1799 7.87925 26.1477 7.88391H21.0122C20.8962 7.88227 20.7811 7.90369 20.6735 7.94693C20.5659 7.99016 20.468 8.05436 20.3854 8.13577C20.3028 8.21718 20.2373 8.3142 20.1925 8.42117C20.1477 8.52815 20.1247 8.64295 20.1247 8.75891C20.1247 8.87487 20.1477 8.98967 20.1925 9.09665C20.2373 9.20362 20.3028 9.30064 20.3854 9.38205C20.468 9.46346 20.5659 9.52765 20.6735 9.57089C20.7811 9.61413 20.8962 9.63555 21.0122 9.63391H24.1499L19.956 13.8278C19.872 13.9084 19.805 14.005 19.7588 14.1118C19.7126 14.2187 19.6882 14.3337 19.687 14.4501C19.6858 14.5665 19.7079 14.682 19.7519 14.7898C19.7959 14.8975 19.861 14.9955 19.9433 15.0778C20.0256 15.1601 20.1235 15.2252 20.2313 15.2692C20.3391 15.3132 20.4546 15.3352 20.571 15.334C20.6874 15.3329 20.8024 15.3085 20.9092 15.2623C21.0161 15.2161 21.1127 15.149 21.1933 15.0651L25.3872 10.8712V14.0089C25.3855 14.1249 25.4069 14.24 25.4502 14.3476C25.4934 14.4552 25.5576 14.5531 25.639 14.6357C25.7204 14.7182 25.8174 14.7838 25.9244 14.8286C26.0314 14.8733 26.1462 14.8964 26.2622 14.8964C26.3781 14.8964 26.4929 14.8733 26.5999 14.8286C26.7069 14.7838 26.8039 14.7182 26.8853 14.6357C26.9667 14.5531 27.0309 14.4552 27.0741 14.3476C27.1174 14.24 27.1388 14.1249 27.1372 14.0089V8.86999C27.1546 8.74402 27.1443 8.61575 27.1071 8.49414C27.0699 8.37252 27.0067 8.26047 26.9218 8.1658C26.8369 8.07112 26.7323 7.99609 26.6155 7.94594C26.4986 7.89578 26.3722 7.87169 26.2451 7.87536ZM14.4326 19.6879C14.2052 19.6946 13.9895 19.7896 13.831 19.9528L9.63716 24.1466V21.0089C9.63876 20.8918 9.61686 20.7756 9.57274 20.6672C9.52863 20.5588 9.4632 20.4603 9.38034 20.3776C9.29747 20.2948 9.19885 20.2296 9.09032 20.1857C8.98179 20.1418 8.86555 20.1201 8.74849 20.1219C8.51672 20.1256 8.29586 20.221 8.13438 20.3873C7.9729 20.5536 7.88399 20.7771 7.88716 21.0089V26.1256C7.86398 26.2632 7.87404 26.4044 7.91651 26.5373C7.95898 26.6702 8.03263 26.7911 8.13131 26.8898C8.22998 26.9884 8.35083 27.0621 8.48376 27.1046C8.61669 27.147 8.75785 27.1571 8.89546 27.1339H14.0122C14.1281 27.1355 14.2432 27.1141 14.3508 27.0709C14.4584 27.0277 14.5563 26.9635 14.6389 26.882C14.7215 26.8006 14.7871 26.7036 14.8318 26.5966C14.8766 26.4897 14.8996 26.3749 14.8996 26.2589C14.8996 26.143 14.8766 26.0281 14.8318 25.9212C14.7871 25.8142 14.7215 25.7172 14.6389 25.6358C14.5563 25.5544 14.4584 25.4902 14.3508 25.4469C14.2432 25.4037 14.1281 25.3823 14.0122 25.3839H10.8745L15.0683 21.1901C15.1948 21.0672 15.2811 20.9089 15.3161 20.7361C15.351 20.5633 15.333 20.3839 15.2643 20.2215C15.1955 20.0591 15.0794 19.9213 14.9309 19.8261C14.7825 19.7308 14.6088 19.6827 14.4326 19.6879ZM20.5661 19.6879C20.392 19.6879 20.2219 19.7399 20.0776 19.8371C19.9332 19.9343 19.8211 20.0724 19.7556 20.2337C19.6901 20.3949 19.6742 20.5721 19.7099 20.7424C19.7456 20.9128 19.8313 21.0687 19.956 21.1901L24.1499 25.3839H21.0122C20.8962 25.3823 20.7811 25.4037 20.6735 25.4469C20.5659 25.4902 20.468 25.5544 20.3854 25.6358C20.3028 25.7172 20.2373 25.8142 20.1925 25.9212C20.1477 26.0281 20.1247 26.143 20.1247 26.2589C20.1247 26.3749 20.1477 26.4897 20.1925 26.5966C20.2373 26.7036 20.3028 26.8006 20.3854 26.882C20.468 26.9635 20.5659 27.0277 20.6735 27.0709C20.7811 27.1141 20.8962 27.1355 21.0122 27.1339H26.1289C26.2665 27.1571 26.4076 27.147 26.5406 27.1046C26.6735 27.0621 26.7943 26.9884 26.893 26.8898C26.9917 26.7911 27.0653 26.6702 27.1078 26.5373C27.1503 26.4044 27.1603 26.2632 27.1372 26.1256V21.0089C27.1388 20.8918 27.1169 20.7756 27.0727 20.6672C27.0286 20.5588 26.9632 20.4603 26.8803 20.3776C26.7975 20.2948 26.6989 20.2296 26.5903 20.1857C26.4818 20.1418 26.3655 20.1201 26.2485 20.1219C26.0167 20.1256 25.7959 20.221 25.6344 20.3873C25.4729 20.5536 25.384 20.7771 25.3872 21.0089V24.1466L21.1933 19.9528C21.1118 19.8689 21.0143 19.8023 20.9065 19.7568C20.7988 19.7113 20.6831 19.6879 20.5661 19.6879Z"
                    fill="white"
                  />
                </svg>
              ) : (
                <svg
                  width="35"
                  height="35"
                  viewBox="0 0 35 35"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ marginRight: "5px", marginBottom: "5px" }}
                >
                  <rect width="35" height="35" rx="5" fill="#4C4C4C" />
                  <path
                    d="M13.5893 8.00012C12.9843 8.0087 12.4995 8.50643 12.508 9.11357V13.5073H8.11448C7.7176 13.5009 7.35076 13.709 7.15124 14.0523C6.94959 14.3934 6.94959 14.8182 7.15124 15.1593C7.35076 15.5025 7.7176 15.7106 8.11448 15.7042H14.7048V9.11357C14.7091 8.81751 14.5933 8.53217 14.383 8.32192C14.1728 8.11168 13.8875 7.99582 13.5893 8.00012ZM20.3764 8.00012C19.8015 8.0087 19.3295 8.46137 19.2973 9.03634C19.2952 9.06208 19.2952 9.08783 19.2952 9.11357V15.7042H25.8855C25.922 15.7042 25.9585 15.7042 25.9949 15.6999C26.5827 15.6463 27.0225 15.14 26.9925 14.5521C26.9646 13.9621 26.4755 13.5009 25.8855 13.5073H21.492V9.11357C21.4962 8.81751 21.3804 8.53217 21.1702 8.32192C20.9599 8.11168 20.6746 7.99582 20.3764 8.00012ZM8.11448 20.2948C7.7176 20.2884 7.35076 20.4965 7.15124 20.8398C6.94959 21.1809 6.94959 21.6057 7.15124 21.9468C7.35076 22.29 7.7176 22.4982 8.11448 22.4917H12.508V26.8855C12.5016 27.2824 12.7097 27.6492 13.053 27.8488C13.3941 28.0504 13.8188 28.0504 14.1599 27.8488C14.5032 27.6492 14.7113 27.2824 14.7048 26.8855V20.2948H8.11448ZM19.2952 20.2948V26.8855C19.2887 27.2824 19.4968 27.6492 19.8401 27.8488C20.1812 28.0504 20.6059 28.0504 20.9471 27.8488C21.2903 27.6492 21.4984 27.2824 21.492 26.8855V22.4917H25.8855C26.2824 22.4982 26.6492 22.29 26.8488 21.9468C27.0504 21.6057 27.0504 21.1809 26.8488 20.8398C26.6492 20.4965 26.2824 20.2884 25.8855 20.2948H19.2952Z"
                    fill="white"
                  />
                </svg>
              )}
            </div>

            <div
              style={{ cursor: "pointer" }}
              onClick={() => {
                setQuestionnaire((prev) => {
                  if (prev)
                    return prev.map((tempquestionnaire) => {
                      if (tempquestionnaire.commands)
                        tempquestionnaire.commands.forEach((command) => {
                          command.answerByQuestion = null;
                          command.answerByVoice = null;
                          editCommand(command);
                        });
                      return tempquestionnaire;
                    });
                });
              }}
            >
              <svg
                width="35"
                height="35"
                viewBox="0 0 35 35"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ marginRight: "5px", marginBottom: "5px" }}
              >
                <rect width="35" height="35" rx="5" fill="#4C4C4C" />
                <path
                  d="M26.1199 8.01027C25.7501 7.95735 25.3682 8.11057 25.1401 8.43181L21.4844 13.5765L20.4573 13.002C19.7423 12.602 18.8441 12.7549 18.3007 13.3682L17.3241 14.4717L25.5226 19.1054L25.9685 17.665C26.2127 16.8783 25.8723 16.0289 25.1531 15.6273L24.3962 15.2041L26.9142 9.43602C27.1242 8.95436 26.9371 8.3923 26.4796 8.13397C26.3654 8.06918 26.2432 8.02792 26.1199 8.01027ZM16.1766 15.9381C12.0557 20.1347 7 20.2984 7 20.2984L11.087 22.7706C11.087 22.7706 13.0103 22.972 13.9386 22.7837C13.0644 23.3761 12.5177 23.6756 12.5177 23.6756L14.7378 25.0346C14.7378 25.0346 17.1164 24.9239 20.0748 23.1547C19.494 24.4264 17.4625 26.5368 17.4625 26.5368L20.625 28C20.625 28 23.2301 26.1119 24.9968 20.9071L16.1766 15.9381Z"
                  fill="white"
                />
              </svg>
            </div>
            <div
              onClick={() => {
                setprintmodal(true);
              }}
            >
              <svg
                width="35"
                height="35"
                viewBox="0 0 35 35"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="35" height="35" rx="5" fill="#4C4C4C" />
                <g clip-path="url(#clip0_544_6450)">
                  <path
                    d="M8.53214 7C8.14677 7.07257 7.86879 7.41331 7.87511 7.80769V27.1923C7.87511 27.6372 8.23837 28 8.68377 28H20.8137C21.2591 28 21.6223 27.6372 21.6223 27.1923V23.1538H20.005V26.3846H9.49243V8.61538H20.005V11.8462H21.6223V7.80769C21.6223 7.36283 21.2591 7 20.8137 7H8.68377C8.6585 7 8.63322 7 8.60795 7C8.58268 7 8.55741 7 8.53214 7ZM24.579 13.512C24.4905 13.5089 24.4053 13.5183 24.3263 13.5625C24.1652 13.6477 24.0736 13.8086 24.0736 13.9916V15.8594C24.0736 15.8594 15.7848 16.1623 15.6079 16.2885C15.3489 16.4715 15.1783 17.0047 15.1783 17.5C15.1783 17.9985 15.3489 18.6043 15.6079 18.7873C15.7848 18.9135 24.0736 19.1406 24.0736 19.1406V21.0084C24.0736 21.1914 24.1652 21.3523 24.3263 21.4375C24.4874 21.5227 24.6801 21.5132 24.8317 21.4123C26.7902 20.0903 28.6792 17.8912 28.7486 17.8029C28.8213 17.7145 28.875 17.6104 28.875 17.5C28.875 17.3896 28.8213 17.2886 28.7486 17.1971C28.6792 17.1088 26.7902 14.9097 24.8317 13.5877C24.7559 13.5373 24.6674 13.5152 24.579 13.512Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_544_6450">
                    <rect
                      width="22.75"
                      height="22.75"
                      fill="white"
                      transform="translate(6.125 6.125)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div
              onClick={() => {
                setUploadmodal(true);
              }}
            >
              <UploadOutlined style={{ fontSize: "35px", marginLeft: "5px" }} />
            </div>
          </div>

          {fullscreen ? (
            <div className="d-flex flex-column gap-2 my-2 mx-1">
              <Button
                onClick={async () => {
                  await runReport("assessment");
                }}
                size="middle"
                style={{
                  backgroundColor: "rgba(76, 76, 76, 1)",
                  color: "white",
                }}
                loading={loading}
              >
                Assessment
              </Button>
              <Button
                onClick={async () => {
                  await runReport("diagnose");
                }}
                disabled={
                  !otherReports ||
                  (!otherReports.question.assessment == "" &&
                    !otherReports.voice.assessment == "")
                }
                size="middle"
                style={{
                  backgroundColor: "rgba(76, 76, 76, 1)",
                  color: "white",
                }}
                loading={loading}
              >
                Diagnosis
              </Button>
              <Button
                onClick={async () => {
                  await runReport("recommendation");
                }}
                disabled={
                  !otherReports ||
                  (!otherReports.question.diagnose == "" &&
                    !otherReports.voice.diagnose == "")
                }
                size="middle"
                style={{
                  backgroundColor: "rgba(76, 76, 76, 1)",
                  color: "white",
                }}
                loading={loading}
              >
                Recommendation
              </Button>
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
      <Modal
        title=""
        open={printmodal}
        onOk={() => {
          uploadExport();
        }}
        confirmLoading={loading}
        okText={"Export"}
        onCancel={() => {
          setprintmodal(false);
        }}
        width={500}
      >
        <div
          className="d-flex flex-column gap-3"
          style={{ alignItems: "center", justifyContent: "center" }}
        >
          <h2 style={{ fontSize: "20px", fontWeight: "600" }}>
            Upload your template file
          </h2>
          <FileUploader
            className="col-10"
            label=" "
            handleChange={(file) =>
              setExportTemplate({ ...exportTamplate, file: file })
            }
            name="file"
            types={["DOC", "DOCX"]}
            maxSize={2}
          />

          <div className="h-line" />
          <div id="downloadButton" className="d-flex flex-row gap-2">
            {/* <span>{template.file.name}</span>
                <Button>Dwonload</Button> */}
          </div>

          {/* <PrintReport
            ref={componentRef}
            patient={patient}
            type={summerytype == "Table" ? "q" : "v"}
            report={{
              title: template.title,
              sections: questionnaire,
              results: otherReports,
            }}
          /> */}
          {/* <div style={{ display: "flex", justifyContent: "center" }}>
            <button
              onClick={handlePrint}
              style={{
                margin: "auto",
                textAlign: "center",
                padding: "10px 20px",
                borderRadius: "10px",
                backgroundColor: "#2E6CDF",
                color: "white",
              }}
            >
              Print this out
            </button>
          </div> */}
        </div>
      </Modal>
      <Modal
        title=""
        open={uploadModal}
        onOk={() => {
          uploadFinal();
        }}
        confirmLoading={loading}
        okText={"Upload"}
        onCancel={() => {
          setUploadmodal(false);
        }}
        width={500}
      >
        <div
          className="d-flex flex-column gap-3"
          style={{ alignItems: "center", justifyContent: "center" }}
        >
          <h2 style={{ fontSize: "20px", fontWeight: "600" }}>
            Upload final report
          </h2>
          <FileUploader
            className="col-10"
            label=" "
            handleChange={(file) => setFinal({ ...final, file: file })}
            name="file"
            types={["PDF"]}
            maxSize={2}
          />
        </div>
      </Modal>
      <Modal
        visible={isModalVisible}
        onOk={() => {
          setIsModalVisible(false);
        }}
        cancelButtonProps={{ style: { display: "none" } }}
        closeIcon={null}
      >
        <p style={{ fontWeight: "700" }}>
          {modalData?.message || "Something went wrong!"}
        </p>
      </Modal>
    </div>
  );
};

const Section = ({
  section,
  questionnaire,
  setQuestionnaire,
  index,
  selectedType,
  template,
  setReportLoading,
}) => {
  const [isActive, setIsActive] = useState(null);
  const [uploadOpen, setuploadOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const {
    startRecording,
    stopRecording,
    togglePauseResume,
    recordingBlob,
    isRecording,
    isPaused,
    recordingTime,
    mediaRecorder,
  } = useAudioRecorder();

  useEffect(() => {
    if (recordingBlob) {
      addAudioElement(recordingBlob);
    } else {
      getAudios();
    }
  }, [recordingBlob]);

  const runSection = async () => {
    setLoading(true);
    var res = await putData(`admin/report-section/${section.id}/run`);
    if (res.status == 200) {
      var temp = questionnaire;
      temp[index] = { ...temp[index], summary: res.data.data.summary };
      setQuestionnaire(temp);
    }
    setLoading(false);
  };

  const getAudios = async () => {
    var temp = questionnaire;
    for (var i in questionnaire[index].audio) {
      var element = questionnaire[index].audio[i];
      if (!element.url) {
        var res = await fetchData(`admin/report-voice/${element.id}`);
        if (res.status == 200) {
          temp[index].audio[i] = {
            ...temp[index].audio[i],
            url: res.data.data.url,
          };
        }
      }
    }
    setQuestionnaire(temp);
  };
  const getTemplate = async (id) => {
    setReportLoading(true);
    var res = await fetchData("admin/report/" + id);
    if (res.status == 200) {
      await setQuestionnaire(
        res.data.data.sections.map((s, id) => {
          var q = s.questions.map((qu) => {
            return { ...qu, title: qu.question };
          });
          var sum = {
            voice: s.results.filter((sumary) => {
              return sumary.inputType == "voice";
            })[0]
              ? s.results.filter((sumary) => {
                  return sumary.inputType == "voice";
                })[0].result
              : null,
            question: s.results.filter((sumary) => {
              return sumary.inputType == "question";
            })[0]
              ? s.results.filter((sumary) => {
                  return sumary.inputType == "question";
                })[0].result
              : null,
          };
          return {
            ...s,
            questions: q,
            audio: s.voices,
            summary: sum,
          };
        })
      );
    }
    setReportLoading(false);
  };
  const addAudioElement = async (blob) => {
    setLoading(true);
    var data = new FormData();
    console.log(new File([blob], "voice.mp3", { type: "audio/mp3" }));
    data.append("file", new File([blob], "voice.mp3", { type: "audio/mp3" }));
    data.append("language", "en");
    data.append("sectionId", section.id);
    var res = await putFormData("admin/report-voice", data);
    if (res.status !== 200) {
      setLoading(false);
      Modal.error({ title: res });

      return;
    }
    const url = URL.createObjectURL(blob);
    var temp = questionnaire;
    temp[index].audio
      ? (temp[index] = {
          ...temp[index],
          audio: [
            ...temp[index].audio,
            {
              url: url,
              blob: new File([blob], "voice.mp3", { type: "audio/mp3" }),
              id: res.data.data.id,
            },
          ],
        })
      : (temp[index] = {
          ...temp[index],
          audio: [
            {
              url: url,
              blob: new File([blob], "voice.mp3", { type: "audio/mp3" }),
              id: res.data.data.id,
            },
          ],
        });
    setQuestionnaire(temp);
    setPlainOptionsVoice([...plainOptionsVoice, res.data.data.id]);
    setLoading(false);
  };
  const runCommand = async (command, section, indexOfCommand) => {
    setLoading(true);
    var okResponse = true;
    for (var i in section.questions) {
      var element = section.questions[i];
      if (okResponse) {
        var res = await putData("admin/report-question/" + element.id, element);
        if (res.status !== 200) {
          okResponse = false;
          setLoading(false);
          Modal.error({ title: res });
        }
      }
    }
    var temp = section.audio.filter((a) => {
      return a.id;
    });
    for (var i in section.audio) {
      if (okResponse && !section.audio[i].id) {
        var element = section.audio[i];
        var data = new FormData();
        data.append("file", element.blob);
        data.append("language", "en");
        data.append("sectionId", section.id);
        var res = await putFormData("admin/report-voice", data);
        if (res.status !== 200) {
          okResponse = false;
          setLoading(false);
          Modal.error({ title: res });
        } else {
          temp.push(res.data.data.id);
        }
      }
    }

    if (okResponse) {
      var res = await putData("admin/report-command/" + command.id + "/run", {
        questions: section.questions
          .filter((q) => {
            return checkedList.q.includes(q.id);
          })
          .map((q) => {
            return q.id;
          }),
        voices:
          temp.length > 0
            ? temp
                .filter((q) => {
                  return checkedList.v.includes(q.id);
                })
                .map((q) => {
                  return q.id;
                })
            : null,
      });
      if (res.status !== 200) {
        setLoading(false);
        Modal.error({ title: res });
      } else {
        Modal.confirm({
          width: "80%",
          height: "80%",
          title:
            "Do you want to keep the previous answer of this command or replace the new answer? ",
          onOk() {
            handleOk(res.data.data, command);
          },
          content: (
            <div className="d-flex flex-row gap-4 col-12">
              <Tabs
                size={"middle"}
                tabBarGutter={18}
                style={{ color: "black", fontWeight: "600", width: "97%" }}
                className="col-12 h-100"
                defaultActiveKey={1}
                type="card"
                items={[
                  {
                    key: "1",
                    label: "New Answer",
                    children: (
                      <div className="d-flex flex-row col-12 gap-2">
                        <div
                          style={{
                            border: "2px solid rgba(217, 217, 217, 1)",
                            borderRadius: "10px",
                          }}
                          className="d-flex flex-column col-6"
                        >
                          <div
                            className="col-12 py-3"
                            style={{
                              fontSize: "16px",
                              fontWeight: "500",
                              textAlign: "center",
                              borderBottom: " 2px solid rgba(217, 217, 217, 1)",
                            }}
                          >
                            Answer by voice
                          </div>
                          <div
                            className="px-3 py-3 col-12"
                            style={{ textAlign: "center" }}
                          >
                            <p
                              style={{
                                fontSize: "13px",
                                fontWeight: "400 ",
                                maxHeight: "40vh",
                                overflowY: "scroll",
                              }}
                            >
                              {res.data.data.answerByVoice}
                            </p>
                          </div>
                        </div>
                        <div
                          style={{
                            border: "2px solid rgba(217, 217, 217, 1)",
                            borderRadius: "10px",
                          }}
                          className="d-flex flex-column col-6"
                        >
                          <div
                            className="col-12 py-3"
                            style={{
                              fontSize: "16px",
                              fontWeight: "500",
                              textAlign: "center",
                              borderBottom: " 2px solid rgba(217, 217, 217, 1)",
                            }}
                          >
                            Answer by Table
                          </div>
                          <div
                            className="px-3 py-3 col-12"
                            style={{ textAlign: "center" }}
                          >
                            <p
                              style={{
                                fontSize: "13px",
                                fontWeight: "400",
                                maxHeight: "40vh",
                                overflowY: "scroll",
                              }}
                            >
                              {res.data.data.answerByQuestion}
                            </p>
                          </div>
                        </div>
                      </div>
                    ),
                  },
                  {
                    key: "2",
                    label: "Previous Answer",
                    children: (
                      <div className="d-flex flex-row col-12 gap-2">
                        <div
                          style={{
                            border: "2px solid rgba(217, 217, 217, 1)",
                            borderRadius: "10px",
                          }}
                          className="d-flex flex-column col-6"
                        >
                          <div
                            className="col-12 py-3"
                            style={{
                              fontSize: "16px",
                              fontWeight: "500",
                              textAlign: "center",
                              borderBottom: " 2px solid rgba(217, 217, 217, 1)",
                            }}
                          >
                            Answer by voice
                          </div>
                          <div
                            className="px-3 py-3 col-12"
                            style={{ textAlign: "center" }}
                          >
                            <p
                              style={{
                                fontSize: "13px",
                                fontWeight: "400",
                                maxHeight: "40vh",
                                overflowY: "scroll",
                              }}
                            >
                              {command.answerByVoice}
                            </p>
                          </div>
                        </div>
                        <div
                          style={{
                            border: "2px solid rgba(217, 217, 217, 1)",
                            borderRadius: "10px",
                          }}
                          className="d-flex flex-column col-6"
                        >
                          <div
                            className="col-12 py-3"
                            style={{
                              fontSize: "16px",
                              fontWeight: "500",
                              textAlign: "center",
                              borderBottom: " 2px solid rgba(217, 217, 217, 1)",
                            }}
                          >
                            Answer by Table
                          </div>
                          <div
                            className="px-3 py-3 col-12"
                            style={{ textAlign: "center" }}
                          >
                            <p
                              style={{
                                fontSize: "13px",
                                fontWeight: "400",
                                maxHeight: "40vh",
                                overflowY: "scroll",
                              }}
                            >
                              {command.answerByQuestion}
                            </p>
                          </div>
                        </div>
                      </div>
                    ),
                  },
                ]}
              />
            </div>
          ),
          icon: <ExclamationCircleFilled />,
          okText: "Replace new answer",
          okType: "danger",
          cancelText: "Keep the previous",
          onCancel() {},
        });
      }
    }

    setLoading(false);
  };
  const handleOk = async (data, command) => {
    setLoading(true);
    setReportLoading(true);
    var temp = { ...command };
    if (selectedType.indexOf("Text") > -1) {
      temp = { ...temp, answerByQuestion: data.answerByQuestion };
    }
    if (selectedType.indexOf("Voice") > -1) {
      temp = { ...temp, answerByVoice: data.answerByVoice };
    }
    var res = await putData("admin/report-command/" + command.id, temp);
    if (res.status != 200) {
      Modal.error({ title: res });
      setReportLoading(false);
      setLoading(false);
    } else {
      await getTemplate(template.id);
      // await getAudios();
      setReportLoading(false);
      setLoading(false);
    }
  };
  const plainOptions = questionnaire[index].questions.map((i) => {
    return i.id;
  });
  const [plainOptionsVoice, setPlainOptionsVoice] = useState(
    questionnaire[index].audio
      ? questionnaire[index].audio.map((i, j) => {
          if (i.id) return i.id;
          else return j;
        })
      : []
  );
  const [uploadfile, setuploadfile] = useState(false);
  const [checkedList, setCheckedList] = useState({
    q: plainOptions,
    v: plainOptionsVoice,
  });
  const checkAll =
    plainOptions.length === checkedList.q.length &&
    plainOptionsVoice.length === checkedList.v.length;
  const indeterminate =
    (checkedList.q.length > 0 && checkedList.q.length < plainOptions.length) ||
    (checkedList.q.length > 0 &&
      checkedList.v.length < plainOptionsVoice.length);
  const onCheckAllChange = (e) => {
    setCheckedList(
      e.target.checked
        ? { q: plainOptions, v: plainOptionsVoice }
        : { q: [], v: [] }
    );
  };

  return (
    <div className="section d-flex flex-column gap-2">
      <div className="section-head d-flex flex-row ">
        {" "}
        <Checkbox
          indeterminate={indeterminate}
          onChange={onCheckAllChange}
          checked={checkAll}
          className="mx-3 col-3 col-lg-2"
        >
          select All to send
        </Checkbox>{" "}
        <div className="col-5 col-lg-6">{section.title}</div>
        <div
          onClick={async () => {
            await runSection();
          }}
          dir="rtl"
          className="col-4 col-lg-3 d-flex gap-2"
          style={{ textAlign: "right", paddingRight: "10px" }}
        >
          <svg
            width="16"
            height="18"
            viewBox="0 0 16 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.727274 0C0.534389 0 0.349405 0.0790176 0.213015 0.21967C0.0766247 0.360322 1.38713e-06 0.551088 1.38713e-06 0.75V0.75293V9V17.2471V17.25C1.38713e-06 17.4489 0.0766247 17.6397 0.213015 17.7803C0.349405 17.921 0.534389 18 0.727274 18C0.878664 17.9995 1.02614 17.9504 1.14915 17.8594L1.15057 17.8608L15.5753 9.68115C15.7019 9.62144 15.8092 9.52551 15.8845 9.40477C15.9597 9.28403 15.9998 9.14355 16 9C16.0001 8.85243 15.9579 8.70812 15.8788 8.58513C15.7998 8.46214 15.6872 8.36595 15.5554 8.30859L1.15057 0.13916C1.0274 0.0486669 0.878509 2.35983e-05 0.727274 0Z"
              fill="black"
            />
          </svg>
          Get Summary of Section
        </div>
      </div>
      {loading ? null : isRecording && isActive == section.id ? (
        <div
          className="d-flex px-2"
          style={{
            justifyContent: "space-between",
            borderBottom: "1px rgba(242, 242, 242, 1)",
          }}
        >
          <div
            className="d-flex"
            style={{ alignItems: "center", paddingLeft: "30px" }}
          >
            <div class="loader">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
          <button
            onClick={() => {
              stopRecording();
            }}
            style={{ border: "none", backgroundColor: "white" }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="35"
              height="35"
              fill="red"
              class="bi bi-stop-circle"
              viewBox="0 0 16 16"
            >
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
              <path d="M5 6.5A1.5 1.5 0 0 1 6.5 5h3A1.5 1.5 0 0 1 11 6.5v3A1.5 1.5 0 0 1 9.5 11h-3A1.5 1.5 0 0 1 5 9.5v-3z" />
            </svg>
          </button>
        </div>
      ) : !questionnaire[index].audio ? null : (
        questionnaire[index].audio.map((a, j) => {
          return (
            <div
              className="d-flex flex-row gap-3 px-3"
              style={{
                display: "flex",
                height: "52px",
                alignItems: "center",
                backgroundColor: "rgba(253, 244, 228, 1)",
                marginTop: "-8px",
                borderBottom: "1px rgba(242, 242, 242, 1)",
              }}
            >
              <Checkbox
                checked={checkedList.v.includes(a.id ?? j) && checkedList}
                onChange={(e) => {
                  e.target.checked
                    ? setCheckedList({
                        ...checkedList,
                        v: [...checkedList.v, a.id ?? j],
                      })
                    : setCheckedList({
                        ...checkedList,
                        v: checkedList.v.filter((v) => {
                          return v != (a.id ?? j);
                        }),
                      });
                }}
              />
              <audio
                style={{
                  width: "90%",
                  height: "80%",
                }}
                src={a.url}
                controls={true}
              />
              <svg
                width="25"
                height="25"
                viewBox="0 0 25 25"
                fill="black"
                xmlns="http://www.w3.org/2000/svg"
                onClick={async () => {
                  setLoading(true);
                  if (a.id) {
                    var res = await deleteData(`admin/report-voice/${a.id}`);
                    if (res.status != 200) {
                      setLoading(false);
                      Modal.error({ title: res });
                      return;
                    }
                  }
                  var temp = questionnaire;
                  temp[index] = {
                    ...temp[index],
                    audio: temp[index].audio.filter((au) => {
                      return au != a;
                    }),
                  };
                  setPlainOptionsVoice(
                    temp[index].audio.map((i, j) => {
                      if (i.id) return i.id;
                      else return j;
                    })
                  );
                  await setQuestionnaire(temp);
                  Modal.success({ title: "audio deleted succesfuly!" });
                  setLoading(false);
                }}
              >
                <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z" />
              </svg>
            </div>
          );
        })
      )}
      {selectedType && selectedType.includes("Voice") ? (
        <div
          style={{
            display: "flex",
            justifyContent: "start",
            height: "37px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              padding: "10px 10px",
            }}
            onClick={() => {
              setIsActive(section.id);
              startRecording();
            }}
          >
            <svg
              width="35"
              height="35"
              viewBox="0 0 35 35"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="17.5" cy="17.5" r="17.5" fill="#FF0000" />
              <path
                d="M17.5 7.69995C15.843 7.69995 14.5 9.03588 14.5 10.6842V16.6526C14.5 18.3009 15.843 19.6368 17.5 19.6368C19.157 19.6368 20.5 18.3009 20.5 16.6526V10.6842C20.5 9.03588 19.157 7.69995 17.5 7.69995ZM10.5 16.6526C10.5 20.1593 13.1094 23.052 16.5 23.5361V26.6H18.5V23.5361C21.8906 23.052 24.5 20.1593 24.5 16.6526H22.5C22.5 19.3991 20.261 21.6263 17.5 21.6263C14.739 21.6263 12.5 19.3991 12.5 16.6526H10.5Z"
                fill="white"
              />
            </svg>
            <strong style={{ color: "#FF0000", marginLeft: "5px" }}>
              Record
            </strong>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              padding: "10px 10px",
            }}
            onClick={() => setuploadOpen(true)}
          >
            <svg
              width="35"
              height="35"
              viewBox="0 0 35 35"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="17.5" cy="17.5" r="17.5" fill="#2A2A2A" />
              <path
                d="M20.1266 24.7309H11.5286C10.3676 24.7309 9.42416 23.7861 9.42416 22.6252L9.42432 11.5285C9.42432 10.3676 10.3676 9.42282 11.5287 9.42282H22.6275C23.7884 9.42282 24.7325 10.3676 24.7325 11.5285V17.307C24.7325 17.598 24.9684 17.8333 25.2581 17.8333C25.5491 17.8333 25.7844 17.5974 25.7844 17.307L25.7842 11.5285C25.7842 9.78736 24.3678 8.36963 22.6266 8.36963H11.5287C9.78752 8.36963 8.37109 9.78736 8.37109 11.5285V22.6256C8.37109 24.3668 9.78752 25.7845 11.5287 25.7845H20.1267C20.4177 25.7845 20.653 25.5486 20.653 25.2582C20.653 24.9677 20.4179 24.7307 20.1267 24.7307L20.1266 24.7309Z"
                fill="white"
              />
              <path
                d="M13.5636 15.0291V19.446C13.4572 19.4305 13.3486 19.4197 13.2361 19.4197C12.2112 19.4197 11.3789 20.0713 11.3789 20.8766C11.3789 21.6818 12.2103 22.3348 13.2361 22.3348C14.2622 22.3348 15.0952 21.6818 15.0952 20.8766L15.0953 15.5344L20.0614 14.4172V18.2156C19.955 18.2014 19.8471 18.1892 19.7354 18.1892C18.7092 18.1892 17.8769 18.8422 17.8769 19.6474C17.8769 20.4527 18.7084 21.1043 19.7354 21.1043C20.761 21.1043 21.5938 20.4527 21.5938 19.6474L21.5935 14.0724V11.8191L13.5636 13.6262L13.5636 15.0291Z"
                fill="white"
              />
              <path
                d="M21.9112 23.5483H23.8101V27.2887C23.8101 27.6034 24.0689 27.8616 24.3842 27.8616H26.1334C26.4495 27.8616 26.7076 27.6035 26.7076 27.2887V23.5483H28.6065C28.9219 23.5483 29.0102 23.3549 28.8026 23.1163L25.637 19.4999C25.4294 19.2627 25.0898 19.2627 24.8822 19.4999L21.7166 23.1163C21.5081 23.3542 21.5965 23.5483 21.9112 23.5483Z"
                fill="white"
              />
            </svg>
            <strong style={{ color: "#2A2A2A", marginLeft: "5px" }}>
              Upload
            </strong>
          </div>
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "start",
            height: "37px",
            opacity: "0.5",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              padding: "10px 10px",
            }}
          >
            <svg
              width="35"
              height="35"
              viewBox="0 0 35 35"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="17.5" cy="17.5" r="17.5" fill="#FF0000" />
              <path
                d="M17.5 7.69995C15.843 7.69995 14.5 9.03588 14.5 10.6842V16.6526C14.5 18.3009 15.843 19.6368 17.5 19.6368C19.157 19.6368 20.5 18.3009 20.5 16.6526V10.6842C20.5 9.03588 19.157 7.69995 17.5 7.69995ZM10.5 16.6526C10.5 20.1593 13.1094 23.052 16.5 23.5361V26.6H18.5V23.5361C21.8906 23.052 24.5 20.1593 24.5 16.6526H22.5C22.5 19.3991 20.261 21.6263 17.5 21.6263C14.739 21.6263 12.5 19.3991 12.5 16.6526H10.5Z"
                fill="white"
              />
            </svg>
            <strong style={{ color: "#FF0000", marginLeft: "5px" }}>
              Record
            </strong>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              padding: "10px 10px",
            }}
          >
            <svg
              width="35"
              height="35"
              viewBox="0 0 35 35"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="17.5" cy="17.5" r="17.5" fill="#2A2A2A" />
              <path
                d="M20.1266 24.7309H11.5286C10.3676 24.7309 9.42416 23.7861 9.42416 22.6252L9.42432 11.5285C9.42432 10.3676 10.3676 9.42282 11.5287 9.42282H22.6275C23.7884 9.42282 24.7325 10.3676 24.7325 11.5285V17.307C24.7325 17.598 24.9684 17.8333 25.2581 17.8333C25.5491 17.8333 25.7844 17.5974 25.7844 17.307L25.7842 11.5285C25.7842 9.78736 24.3678 8.36963 22.6266 8.36963H11.5287C9.78752 8.36963 8.37109 9.78736 8.37109 11.5285V22.6256C8.37109 24.3668 9.78752 25.7845 11.5287 25.7845H20.1267C20.4177 25.7845 20.653 25.5486 20.653 25.2582C20.653 24.9677 20.4179 24.7307 20.1267 24.7307L20.1266 24.7309Z"
                fill="white"
              />
              <path
                d="M13.5636 15.0291V19.446C13.4572 19.4305 13.3486 19.4197 13.2361 19.4197C12.2112 19.4197 11.3789 20.0713 11.3789 20.8766C11.3789 21.6818 12.2103 22.3348 13.2361 22.3348C14.2622 22.3348 15.0952 21.6818 15.0952 20.8766L15.0953 15.5344L20.0614 14.4172V18.2156C19.955 18.2014 19.8471 18.1892 19.7354 18.1892C18.7092 18.1892 17.8769 18.8422 17.8769 19.6474C17.8769 20.4527 18.7084 21.1043 19.7354 21.1043C20.761 21.1043 21.5938 20.4527 21.5938 19.6474L21.5935 14.0724V11.8191L13.5636 13.6262L13.5636 15.0291Z"
                fill="white"
              />
              <path
                d="M21.9112 23.5483H23.8101V27.2887C23.8101 27.6034 24.0689 27.8616 24.3842 27.8616H26.1334C26.4495 27.8616 26.7076 27.6035 26.7076 27.2887V23.5483H28.6065C28.9219 23.5483 29.0102 23.3549 28.8026 23.1163L25.637 19.4999C25.4294 19.2627 25.0898 19.2627 24.8822 19.4999L21.7166 23.1163C21.5081 23.3542 21.5965 23.5483 21.9112 23.5483Z"
                fill="white"
              />
            </svg>
            <strong style={{ color: "#2A2A2A", marginLeft: "5px" }}>
              Upload
            </strong>
          </div>
        </div>
      )}
      {questionnaire[index].questions.map((q, i) => {
        return (
          <>
            {" "}
            <div
              style={{
                backgroundColor: "rgba(242, 242, 242, 1)",
              }}
              className="section-q d-flex flex-row px-3 gap-2"
            >
              <Checkbox
                checked={checkedList.q.includes(q.id) && checkedList}
                onChange={(e) => {
                  e.target.checked
                    ? setCheckedList({
                        ...checkedList,
                        q: [...checkedList.q, q.id],
                      })
                    : setCheckedList({
                        ...checkedList,
                        q: checkedList.q.filter((v) => {
                          return v != q.id;
                        }),
                      });
                }}
              />
              <div
                style={{ color: "rgba(46, 108, 223, 1)", fontWeight: "500" }}
              >
                {" "}
                Q {i + 1}
              </div>
              <Input
                style={{ border: "none" }}
                disabled
                className="col-11"
                value={questionnaire[index].questions[i].title}
              />
            </div>
            <div
              className="section-q d-flex flex-row px-3 gap-2"
              style={{ borderBottom: "none" }}
            >
              <div
                style={{
                  color: "rgba(46, 108, 223, 1)",
                  fontWeight: "500",
                  marginLeft: "25px",
                }}
              >
                {" "}
                A {i + 1}
              </div>

              <Form.Item
                className="col-11"
                initialValue={questionnaire[index].questions[i].answer}
                style={{ marginBottom: "0px" }}
              >
                <Input
                  disabled={!selectedType || !selectedType.includes("Text")}
                  style={{ border: "none" }}
                  onChange={(e) => {
                    var temp = questionnaire;
                    temp[index].questions[i] = {
                      ...temp[index].questions[i],
                      answer: e.target.value,
                    };
                    setQuestionnaire(temp);
                  }}
                  defaultValue={questionnaire[index].questions[i].answer}
                />
              </Form.Item>
            </div>
          </>
        );
      })}
      {section.commands.map((command, indexOfCommand) => {
        return (
          <div className="section-c d-flex flex-row">
            {" "}
            <div
              className="run-c"
              style={{
                width: "50px",
                backgroundColor: "rgba(189, 223, 174, 1)",
                marginTop: "-10px",
                height: "48px",
                justifyContent: "center",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
              onClick={async () => {
                await runCommand(command, questionnaire[index], indexOfCommand);
              }}
            >
              <svg
                width="16"
                height="18"
                viewBox="0 0 16 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.727274 0C0.534389 0 0.349405 0.0790176 0.213015 0.21967C0.0766247 0.360322 1.38713e-06 0.551088 1.38713e-06 0.75V0.75293V9V17.2471V17.25C1.38713e-06 17.4489 0.0766247 17.6397 0.213015 17.7803C0.349405 17.921 0.534389 18 0.727274 18C0.878664 17.9995 1.02614 17.9504 1.14915 17.8594L1.15057 17.8608L15.5753 9.68115C15.7019 9.62144 15.8092 9.52551 15.8845 9.40477C15.9597 9.28403 15.9998 9.14355 16 9C16.0001 8.85243 15.9579 8.70812 15.8788 8.58513C15.7998 8.46214 15.6872 8.36595 15.5554 8.30859L1.15057 0.13916C1.0274 0.0486669 0.878509 2.35983e-05 0.727274 0Z"
                  fill="white"
                />
              </svg>
            </div>
            <Spin spinning={loading}>
              <h3>{command.prompt}</h3>
            </Spin>
          </div>
        );
      })}
      <Modal
        closeIcon={
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.418896 23.4842C1.01733 24.0813 1.93529 24.0813 2.53377 23.4842L11.951 14.089L21.3682 23.4842C21.9268 24.1213 22.8445 24.161 23.483 23.6434C24.1215 23.1257 24.1613 22.1704 23.6425 21.5334C23.6027 21.4937 23.5626 21.414 23.483 21.3743L14.0658 11.9791L23.483 2.58384C24.0815 2.02651 24.1215 1.07098 23.5629 0.473901C23.0043 -0.12314 22.0465 -0.163128 21.448 0.394202L11.951 9.86904L2.53385 0.473822C1.93541 -0.0835074 0.977621 -0.0437966 0.418974 0.553521C-0.0998546 1.11085 -0.0998546 2.02643 0.418974 2.58377L9.83616 11.979L0.418974 21.3742C-0.139658 21.9713 -0.139658 22.8871 0.418974 23.4842L0.418896 23.4842Z"
              fill="black"
            />
          </svg>
        }
        title="Upload Audio"
        open={uploadOpen}
        footer={null}
        onCancel={() => {
          setuploadOpen(false);
        }}
      >
        <Cropper
          Save={(blob) => {
            addAudioElement(blob);
            setuploadfile(false);
            setuploadOpen(false);
          }}
          setLoading={setLoading}
        />
      </Modal>
    </div>
  );
};

export default ConfirmReport;
